/**
 * quizChime.js — Petit jingle synthétique (Web Audio API) pour signaler
 * une évolution du podium ou un nouveau champion en direct.
 * Aucun asset externe requis.
 */

// Un seul AudioContext partagé pour éviter les créations à répétition.
let ctx = null;
function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      ctx = AudioCtx ? new AudioCtx() : null;
    } catch {
      ctx = null;
    }
  }
  // Sur certains navigateurs le contexte est suspendu tant qu'aucune interaction
  // utilisateur n'a eu lieu — on essaie de le reprendre.
  if (ctx && ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  return ctx;
}

/**
 * Joue une petite note sinusoïdale douce avec enveloppe ADSR minimale.
 */
function playNote(freq, when, duration = 0.28, gain = 0.16) {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(freq, when);
  g.gain.setValueAtTime(0, when);
  g.gain.linearRampToValueAtTime(gain, when + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, when + duration);
  osc.connect(g).connect(c.destination);
  osc.start(when);
  osc.stop(when + duration + 0.02);
}

/**
 * Petit tintement 3 notes ascendant — évolution du podium
 * (ex : nouveau top 3 qui rejoint le classement).
 */
export function playPodiumUpdate() {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime;
  playNote(523.25, t, 0.18);        // C5
  playNote(659.25, t + 0.09, 0.18); // E5
  playNote(783.99, t + 0.18, 0.30); // G5
}

/**
 * Jingle nouveau champion : arpège majeur montant + accord final glorieux.
 */
export function playNewChampion() {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime;
  playNote(523.25, t, 0.16, 0.14);        // C5
  playNote(659.25, t + 0.10, 0.16, 0.14); // E5
  playNote(783.99, t + 0.20, 0.16, 0.14); // G5
  playNote(1046.5, t + 0.30, 0.35, 0.20); // C6
  // Accord final glorieux (C majeur)
  playNote(523.25, t + 0.55, 0.6, 0.10);
  playNote(659.25, t + 0.55, 0.6, 0.10);
  playNote(783.99, t + 0.55, 0.6, 0.10);
}
